<div class="step-main-container">
    <div class="center-start flex-col" [ngClass]="{ inactive: !warning && !complete && !active }">
        @if (complete) {
            <mat-icon class="mat-primary"> check_circle </mat-icon>
        }
        @if (active && !complete && !warning && !error) {
            <mat-icon class="mat-accent"> label </mat-icon>
        }
        @if (warning && !complete) {
            <mat-icon class="mat-warn"> warning </mat-icon>
        }
        @if (error && !complete) {
            <mat-icon style="color: red"> error </mat-icon>
        }
        @if (!active && !warning && !error && !complete) {
            <mat-icon> label_outline </mat-icon>
        }
    </div>
    <div class="center-start flex-col">
        <span [ngClass]="active ? 'mat-body-strong' : 'mat-body-2'">{{ label }}</span>
    </div>
    @if (divider !== false) {
        <div class="divider start-center flex-row flex">
            <div class="flex-col flex">
                <mat-divider [inset]="true"></mat-divider>
            </div>
        </div>
    }
</div>
@if (showMessage) {
    <div class="step-content-parent">
        <div class="shrinkable-child">
            <ng-container *ngTemplateOutlet="cbStepMessageTemplate"></ng-container>
        </div>
    </div>
}
<ng-template #cbStepMessageTemplate>
    <ng-content select="[cbStepMessage]"> </ng-content>
</ng-template>
@if (showCard) {
    <div class="step-card-container" #stepCardContainer>
        <div class="step-card-wrapper" cbStepWrapperMaxWidth #stepCardWrapper>
            <mat-card
                class="step-card"
                [cbApplyClassIfHasContent]="{ ele: stepCardContainer, class: 'visible' }"
            >
                <mat-card-content>
                    <ng-container *ngTemplateOutlet="cbStepCardTemplate"></ng-container>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="step-card-height" [cbStepCardHeight]="stepCardWrapper"></div>
    </div>
}
<ng-template #cbStepCardTemplate>
    <ng-content select="[cbStepCard]"> </ng-content>
</ng-template>
